@let dataItem = onboardingDataItem$ | async;

@if (dataItem) {

<div class="rpc-onboarding" (swipeleft)="next()" (swiperight)="previous()" statusBarMode [whenVisible]="'Default'">

    <rpc-button class="rpc-onboarding-close" [iconName]="'cross'" [title]="'ONBOARDING_DIALOG.BUTTONS.CLOSE'"
        (clicked)="close()">
    </rpc-button>

    @let selectedItemIndex = selectedItemIndex$ | async;
    @let itemsImages = itemsImages$ | async;

    <div class="rpc-onboarding-body" [class.rpc-onboarding-body--multiple]="itemsImages && itemsImages.length > 1">

        <div class="rpc-onboarding-section">

            <div class="rpc-onboarding-image-wrap">

                @for (item of itemsImages; track $index) {

                <default-image class="rpc-onboarding-image" [image]="item" [useBackgroundImage]="true"
                    [class.rpc-onboarding-image--active]="$index === selectedItemIndex" [title]="dataItem.title">
                </default-image>

                }

            </div>

            <div class="rpc-onboarding-inner">

                <div class="rpc-onboarding-title rpc-title-font">
                    {{dataItem.title}}
                </div>

                @if (dataItem.titleSecond) {
                <div class="rpc-onboarding-title rpc-title-font">
                    {{dataItem.titleSecond}}
                </div>
                }

                @if (dataItem.description) {
                <div class="rpc-onboarding-text" [innerHTML]="dataItem.description">
                </div>
                }

                @if (dataItem.descriptionSecond) {
                <div class="rpc-onboarding-text">
                    {{dataItem.descriptionSecond}}
                </div>
                }

                @if (dataItem.descriptionList && dataItem.descriptionList.length > 0) {
                <ul class="rpc-onboarding-list">

                    @for (item of dataItem.descriptionList; track $index) {
                    <li [innerHTML]="item.description">
                    </li>
                    }

                </ul>
                }

                @if (dataItem.redirectButton) {
                <div class="rpc-onboarding-button-wrap">

                    <rpc-button class="rpc-onboarding-button" [text]="dataItem.redirectButton.title"
                        [appearanceType]="'flat'" [color]="'accent'" [isMainButton]="true"
                        (clicked)="redirect(dataItem.redirectButton.url, dataItem.redirectButton.isExternal)">
                    </rpc-button>

                </div>
                }

            </div>

        </div>

        @if (itemsImages && itemsImages.length > 1) {
        <div class="rpc-onboarding-footer">

            <rpc-button class="rpc-onboarding-nav rpc-onboarding-nav--prev" [appearanceType]="'stroke'"
                [iconName]="'arrow-left'" [title]="'ONBOARDING_DIALOG.BUTTONS.PREVIOUS' | translate"
                [iconSquareButton]="true" (clicked)="previous()">
            </rpc-button>

            @if (itemsImages) {
            <div class="rpc-onboarding-counter">
                {{selectedItemIndex! + 1}} / {{itemsImages.length}}
            </div>
            }

            <rpc-button class="rpc-onboarding-nav rpc-onboarding-nav--next" [appearanceType]="'stroke'"
                [iconName]="'arrow-right'" [title]="'ONBOARDING_DIALOG.BUTTONS.NEXT'" [iconSquareButton]="true"
                (clicked)="next()">
            </rpc-button>

        </div>
        }

    </div>

</div>

}